import { track } from './analytics';

/**
 * Scoped click listener: fires a `cta_click` GA4 event only for clicks that carry signal —
 * outbound links, and elements explicitly opted in with `[data-track-cta]`.
 *
 * The previous version fired on EVERY `<a>/<button>/[role="button"]` click, which flooded
 * GA4 event volume and made DebugView and funnel reports unusable. Meaningful conversions
 * (sign_up, contact_host, booking_request, …) are tracked at their real call sites instead;
 * this listener now only covers outbound exits and hand-picked CTAs.
 *
 * GA4 Enhanced Measurement is intentionally OFF in this template (its auto-listeners break
 * in-app SPA navigation, see `analytics/handlers.js`). Attached in the capture phase so
 * clicks are caught even when inner handlers stop propagation.
 */
export function initClickTracking() {
  if (typeof document === 'undefined') {
    return;
  }
  document.addEventListener(
    'click',
    e => {
      const el = e.target.closest('a,button,[role="button"]');
      if (!el) {
        return;
      }
      const href = el.getAttribute('href') || '';
      const outbound = /^https?:\/\//.test(href) && !href.includes('cowork24.ch');
      const optedIn = el.closest('[data-track-cta]');
      if (!outbound && !optedIn) {
        return;
      }
      track.ctaClick({
        click_text: (el.innerText || el.getAttribute('aria-label') || '').trim().slice(0, 100),
        click_url: href,
        click_id: el.id || (optedIn ? optedIn.getAttribute('data-track-cta') : '') || '',
        outbound,
        page_path: window.location.pathname,
      });
    },
    { capture: true }
  );
}
